import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

// import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

import {
  isTest,
} from '../../../redux/challengeSlice';

export default function LoginFailure() {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const signinResultState = useSelector((state) => state.challenge.signinResult);
  const isTestState = useSelector((state) => state.challenge.isTest);

  useEffect(() => {
    challengeFailureTimer();
  }, []);

  const challengeFailureTimer = () => {
    // setDisableButtons(true);
    setTimeout(() => {
      // resetChallenge();
      if (isTestState) {
        dispatch(isTest(false));
        navigate("/register-pattern");
        // Better have a message about resetting pattern and creating a new one then redirect to register-pattern


        // navigate("/success");
      } else {
        // navigate("/register-pattern");
        navigate("/challenge");
        // Better have a message about resetting pattern and creating a new one then redirect to register-pattern
      }
    }, 2000);
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#F44334',
            color: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '250px',
          }}
        >
          <Box>
            <ClearIcon
              sx={{
                color: '#FFFFFF',
                fontSize: '8rem',
              }}
            />
          </Box>
          <Typography
            variant='h4'
          >
            Pattern Failed

          </Typography>
          <br />
          <Typography
            variant='body1'
          >
            Try again.
          </Typography>
        </Box>
        {isTestState ?
          <Typography
            variant='body1'
          >
            This was a test. Reset your pattern and try again.
          </Typography>
          : null
        }
      </Box>
    </React.Fragment>
  );

}